"use client";

import { toast } from "sonner";

import { authClient } from "@/lib/auth-client";

interface ConnectLinkedinButtonProps {
  returnUrl?: string;
  label?: string;
  fullWidth?: boolean;
}

// Links a LinkedIn OAuth account to the already-signed-in user, then sends them
// back to /join. The `account.create.after` hook in auth.ts marks the profile
// PENDING and fires enrichment, so no extra client call is needed.
export function ConnectLinkedinButton({
  returnUrl,
  label = "Connect LinkedIn",
  fullWidth = false,
}: ConnectLinkedinButtonProps) {
  const handleConnect = () => {
    const back = returnUrl
      ? `/join?returnUrl=${encodeURIComponent(returnUrl)}`
      : "/join";
    authClient
      .linkSocial({
        provider: "linkedin",
        callbackURL: `${window.location.origin}${back}`,
      })
      .catch(() => {
        toast.error("Couldn't connect LinkedIn", {
          description:
            "This LinkedIn account may already be linked to another user. Try a different one, or add a resume instead.",
        });
      });
  };

  return (
    <button
      type="button"
      onClick={handleConnect}
      className={`bg-marketing-blue hover:bg-marketing-blue-dark inline-flex cursor-pointer items-center justify-center rounded-full px-7 font-medium tracking-[-0.01em] text-white transition-colors ${
        fullWidth ? "h-14 w-full text-base" : "h-12 text-[15px]"
      }`}
    >
      {label}
    </button>
  );
}
